import type { ReactNode } from "react";
import {
  Tab as AriaTab,
  TabList as AriaTabList,
  TabPanel as AriaTabPanel,
  Tabs as AriaTabs,
  type Key,
} from "react-aria-components";
import { cx } from "../cx.js";
import styles from "./Tabs.module.css";

/** Registerkarten (Tastatur: Pfeiltasten, Pos1/Ende; RTL durch React Aria) */
export function Tabs({
  label,
  items,
  selectedKey,
  onSelectionChange,
  className,
}: {
  label: string;
  items: Array<{ id: string; title: ReactNode; content: ReactNode; badge?: ReactNode }>;
  selectedKey?: string;
  onSelectionChange?: (key: string) => void;
  className?: string;
}) {
  return (
    <AriaTabs
      className={cx(styles.tabs, className)}
      selectedKey={selectedKey}
      onSelectionChange={(k: Key) => onSelectionChange?.(String(k))}
    >
      <AriaTabList aria-label={label} className={styles.list}>
        {items.map((i) => (
          <AriaTab key={i.id} id={i.id} className={styles.tab}>
            {i.title}
            {i.badge ? <span className={styles.badge}>{i.badge}</span> : null}
          </AriaTab>
        ))}
      </AriaTabList>
      {items.map((i) => (
        <AriaTabPanel key={i.id} id={i.id} className={styles.panel}>
          {i.content}
        </AriaTabPanel>
      ))}
    </AriaTabs>
  );
}
